import * as React from 'react';
import { ISearchCatalogItem } from '../../../../types/geo';
import { getSuggestLinkText } from '../../geo_textfield/getSuggestLinkText';
import * as styles from './LocationSearchDropdown.css';

export interface ILocationSearchDropdownProps {
  list: ISearchCatalogItem[];
  query: string;
  onSelect(item: ISearchCatalogItem): void;
}

export const LocationSearchDropdown = React.forwardRef<HTMLDivElement, ILocationSearchDropdownProps>(
  function LocationSearchDropdown({ list, query, onSelect }, ref) {
    return (
      <div ref={ref} className={styles['container']}>
        {list.length ? (
          <ul role="listbox" className={styles['list']}>
            {list.map(item => (
              <li
                role="option"
                key={`location-${item.displayName}`}
                className={styles['item']}
                onClick={() => onSelect(item)}
              >
                {getSuggestLinkText(item.displayName, query, [], styles['item-text'])}
              </li>
            ))}
          </ul>
        ) : (
          <div className={styles['empty']}>Ничего не найдено</div>
        )}
      </div>
    );
  },
);
